import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private toastr: ToastrService,
    private cookie: CookieService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = JSON.parse(localStorage.getItem('sessionAuthState') || '{}').access_token || '';
    if (accessToken) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` }
      });
    }

    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          setTimeout(() => {
            if (error.error.errors && error.error.errors.length > 0) {
              error.error.errors.forEach((element: any) => {
                this.toastr.error(element.message, 'Error', {
                  progressBar: true,
                });
              });
            } else if (error.error.message && error.error.message.length > 0) {
              error.error.message.forEach((element: any) => {
                this.toastr.error(element, 'Error', {
                  progressBar: true,
                });
              });
            }
            else {
              this.toastr.error('Ha ocurrido un error desconocido, vuelve a intentarlo.', 'Error', {
                progressBar: true,
              });
            }
          }, 100);

          return throwError(() => error);
        })
      );
  }
}
